export const BASIC_URL = 'https://exairaq.net/api' 
// export const BASIC_URL = 'http://localhost:8000/api' 
// export const BASIC_URL = 'http://localhost:3001' 
// export const BASIC_URL_PATH_BACKEND = 'http://localhost:3001' 
